module.exports = __webpack_public_path__ + "prod/1.42.2/img/internet-chain.593ef434.png";